module.exports = __webpack_public_path__ + "static/media/beer.a038f847.png";